module.exports = "<button type=\"submit\" class=\"btn btn-logout\" id=\"btnSupport\" (click)=\"OnContactUsClick()\">Visit Customer Care & Support</button>\r\n\r\n<!-- Roshan\r\n  <button type=\"submit\" class=\"btn btn-logout\" id=\"btnSupport\">Visit Customer Care & Support</button> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/faq/faq.component.html
// module id = ./src/app/shoppingcart/faq/faq.component.html
// module chunks = main